"use strict";

var BootstrapPrompt = require("./BootstrapPrompt");
var Spinner = require("../client/Spinner");

// PartialResponseHelper
module.exports = {
	handleErrorResponse(response) {
		var jsonResponse;
		if (typeof response === "string") {
			try {
				jsonResponse = JSON.parse(response);
			} catch (exception) {
				jsonResponse = {}; //I guess it wasn't JSON
			}
		} else if (typeof response === "object") {
			jsonResponse = response;
		} else {
			//This response was not handled
			return false;
		}

		//Was an invalid partial requested
		if (jsonResponse.message === "Partial Invalid") {
			var newerPageVersionMessage = (window.GENERAL_MESSAGES || {}).NEWER_PAGE_VERSION;

			//If there is a message we are supposed to show, show it
			if (newerPageVersionMessage) {
				window.BUTTON_LABELS = window.BUTTON_LABELS || {};
				BootstrapPrompt.show({
					buttons: [{
						label: window.BUTTON_LABELS.REFRESH || "Refresh",
						action: (dialogRef) => {
							Spinner.showSpinner();
							window.location.reload();
							dialogRef.close();
						}
					}, {
						label: window.BUTTON_LABELS.CANCEL || "Cancel",
						action: (dialogRef) => {
							dialogRef.close();
						}
					}],
					message: newerPageVersionMessage
				});
			}
			//This response was handled
			return true;
		}

		//This response was not handled
		return false;
	}
};



// WEBPACK FOOTER //
// ./Javascript/shared/PartialResponseHelper.jsx